/**
 * 公式引擎 - ttx.formula 桥接层
 *
 * 从 @formula-sdk/core 导入核心能力，
 * scheduleFormulas 调后端 /formula/compute 统一计算，
 * 暴露到 window.ttx.formula 供低代码平台各组件使用。
 */
import {
  normalizeFormula,
  shouldRunFormula,
  runFormula,
  runExpressionFormula,
  runJsFormula,
  applyFormulas,
  resolveFormulaSources,
  scheduleFormulas as sdkScheduleFormulas,
  createFormulaScheduler,
  applyFormulasToRecords,
  collectFormulaFields,
  collectFormulaSources,
  extractEnumCodes,
  extractSourceAliases,
  buildScopeFn,
  createScope,
  shouldAutoReturn,
  SAFE_HELPERS,
} from '@xkki/formula';

window.ttx = window.ttx || {};
ttx.formula = {};

// ---- 枚举缓存（沙箱 getEnumDisplayName 读取） ----
ttx.formula._enumCache = {};

// ---- scheduleFormulas：走后端统一计算 ----
function backendScheduleFormulas(options) {
  const { formulaFields, values, changedKeys, onUpdate } = options || {};
  if (!formulaFields || !formulaFields.length) return;

  ttx.ajax.request({
    url: '/api/formula/compute',
    method: 'POST',
    data: { fields: formulaFields, values: values || {}, changedKeys: changedKeys || [] },
  }).then(({ res }) => {
    const data = res?.data || res || {};
    const updates = data.updates || {};
    const allValues = data.values || {};
    if (onUpdate) onUpdate(updates, allValues);
  }).catch((err) => {
    const result = applyFormulas({
      fields: formulaFields,
      values: values || {},
      changedKeys: changedKeys || [],
      context: { sources: {} },
    });
    if (result && onUpdate) onUpdate(result.updates, result.values);
  });
}

// ---- 暴露全部 API 到 ttx.formula ----
Object.assign(ttx.formula, {
  normalizeFormula,
  shouldRunFormula,
  runFormula,
  runExpressionFormula,
  runJsFormula,
  applyFormulas,
  resolveFormulaSources,
  // scheduleFormulas 替换为后端计算版本（baseModel._executeFormulas 调用）
  scheduleFormulas: backendScheduleFormulas,
  createFormulaScheduler,
  applyFormulasToRecords,
  collectFormulaFields,
  collectFormulaSources,
  extractEnumCodes,
  extractSourceAliases,
  buildScopeFn,
  createScope,
  shouldAutoReturn,
  SAFE_HELPERS,
});
